/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Col,
  QuestionAnswerContainer,
  type Question,
} from "@components";
import type { EmployeeAbsenceAdditionalInfo } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  additionalInfo: EmployeeAbsenceAdditionalInfo,
  onDismissHandler: () => void,
  onSubmit: (formData: Object) => void,
  absenceId: number,
}>;

type ComponentState = $Exact<{
  additionalQuestionAnswers: Object,
  isValid: boolean,
}>;

export class EditAdditionalInfoModal extends React.Component<Props, ComponentState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      additionalQuestionAnswers: {
        [this.props.additionalInfo.question.id]: {
          answer: this.props.additionalInfo.answer.value,
          consentToShare: this.props.additionalInfo.consentToShare,
          id: this.props.additionalInfo.question.id,
        },
      },
      isValid: true,
    };
  }

  submitForm = () => {
    this.props.onSubmit({
      id: this.props.additionalInfo.id,
      question: {
        id: this.props.additionalInfo.question.id,
      },
      answer: {
        value: this.state.additionalQuestionAnswers[this.props.additionalInfo.question.id].answer,
      },
      consentToShare: this.state.additionalQuestionAnswers[this.props.additionalInfo.question.id]
        .consentToShare,
    });
  };

  handleChange = (values: Object) => {
    // This is very weird and not working 'validation' logic. Will discuss it with qa team
    this.setState({
      additionalQuestionAnswers: values.answers,
      // isValid: values.isValid,
    });
  };

  get questions(): Array<Question> {
    const { additionalInfo } = this.props;
    return [{ ...additionalInfo.question, type: additionalInfo.question.questionType }];
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("ADDITIONAL_INFO_WITH_ID", { id: this.props.absenceId })}
        </ModalHeader>
        <ModalBody>
          <Col sm={{ size: 8, offset: 2 }}>
            <QuestionAnswerContainer
              questions={this.questions}
              onChange={this.handleChange}
              answers={this.state.additionalQuestionAnswers}
              columnsPerRow={1}
            />
          </Col>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm} disabled={!this.state.isValid}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(EditAdditionalInfoModal);
